import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import { NavSectionHorizontal } from 'src/components/nav-section';
import useAuth from 'src/hooks/useAuth';
import { HEADER } from '../../../config';
import { AdminNavConfig } from './AdminNavConfig';
import { NavConfig } from './NavConfig';
import { useDispatch, useSelector } from 'src/redux/store';
import { getMenu } from 'src/redux/slices/menu';
import React from 'react';
import useCompany from 'src/hooks/useCompany';

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  boxShadow: theme.customShadows.z8,
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

function NavbarHorizontal() {
  const { user } = useAuth();
  const isSuperAdmin = user?.roles?.map((role) => role.id).includes(1);
  const { menus } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const { companyId } = useCompany();

  React.useEffect(() => {
    dispatch(getMenu());
  }, [dispatch, companyId]);

  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={menus} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
